import { apiGet, apiPost, apiPut, apiDelete } from './client';
import type { IntegrationCredential, DiagnosticsResult } from '../types';

export async function getCredentials(): Promise<IntegrationCredential[]> {
  return apiGet<IntegrationCredential[]>('/integrations/credentials');
}

export async function upsertCredential(data: {
  provider: string;
  companyId?: string;
  baseUrl?: string;
  apiKey?: string;
  username?: string;
  password?: string;
  isActive?: boolean;
}): Promise<IntegrationCredential> {
  return apiPut<IntegrationCredential>('/integrations/credentials', data);
}

export async function deleteCredential(id: string): Promise<void> {
  return apiDelete<void>(`/integrations/credentials/${id}`);
}

export async function testSgpCredential(companyId?: string, document?: string): Promise<Record<string, unknown>> {
  return apiPost<Record<string, unknown>>('/integrations/sgp/test', { companyId, document });
}

export async function testSgpReadOnlyFlow(companyId?: string, document?: string): Promise<Record<string, unknown>> {
  return apiPost<Record<string, unknown>>('/integrations/sgp/read-only-diagnostics', { companyId, document });
}

export async function testRadius(username: string, companyId?: string, document?: string): Promise<Record<string, unknown>> {
  return apiPost<Record<string, unknown>>('/integrations/sgp/radius-test', { companyId, username, document });
}

export async function getDiagnostics(): Promise<DiagnosticsResult[]> {
  return apiGet<DiagnosticsResult[]>('/integrations/diagnostics');
}

export async function listSgpOperations(): Promise<unknown[]> {
  return apiGet<unknown[]>('/integrations/sgp/operations');
}

export async function listSgpAuthorizations(companyId?: string): Promise<unknown[]> {
  const params = companyId ? `?companyId=${companyId}` : '';
  return apiGet<unknown[]>(`/integrations/sgp/authorizations${params}`);
}

export async function requestSgpAuthorization(data: {
  operationId: string;
  companyId?: string;
  conversationId?: string;
  customerId?: string;
  payload: Record<string, unknown>;
  reason: string;
}): Promise<unknown> {
  return apiPost<unknown>('/integrations/sgp/authorizations', data);
}

export async function approveSgpAuthorization(id: string, reason?: string): Promise<unknown> {
  return apiPost<unknown>(`/integrations/sgp/authorizations/${id}/approve`, { reason });
}

export async function rejectSgpAuthorization(id: string, reason: string): Promise<unknown> {
  return apiPost<unknown>(`/integrations/sgp/authorizations/${id}/reject`, { reason });
}
